<template>
    <div class="fill-height of-y d-flex justify-space-around align-baseline flex-wrap px-4">

        <div v-if="startingUp" class="fill-height d-flex align-center justify-center">
            <app-centre-loader label="Loading Company Information"></app-centre-loader>
        </div>

        <template v-else>
            <v-card style="max-width: 600px; width: 100%" class="mx-4 my-4">
                <div class="dlg-title-bar">
                    Company Information
                </div>
                <v-card-text>
                    <v-form ref="companyInfo" @submit="$event.preventDefault()">
<!--Site Name-->
                        <v-text-field
                                v-model="companyInfo.name"
                                class="pb-2"
                                flat
                                prepend-icon="mdi-domain"
                                label="Site Name"
                                hide-details="auto"
                                color="primary"
                                dark
                                :rules="[validationRules.required]"
                                :error-messages="companyErrors"
                        />
                        <!--Company Name-->
                        <v-text-field
                                v-model="companyInfo.companyName"
                                class="pb-2"
                                flat
                                prepend-icon="mdi-domain"
                                label="Company Name"
                                hide-details="auto"
                                color="primary"
                                dark
                                :rules="[validationRules.required]"
                        />
                        <!--Tax No-->
                        <v-text-field
                                v-model="companyInfo.taxNo"
                                class="pb-2"
                                flat
                                prepend-icon="mdi-currency-usd"
                                label="Vat No"
                                hide-details="auto"
                                color="primary"
                                dark
                        />
                        <!--Registration No-->
                        <v-text-field
                                v-model="companyInfo.companyRegistrationNo"
                                class="pb-2"
                                flat
                                prepend-icon="mdi-file-sign"
                                label="Business Registration No"
                                hide-details="auto"
                                color="primary"
                                dark
                        />
                        <!--Address-->
                        <v-text-field
                                v-model="companyInfo.address.line1"
                                class="pb-2"
                                flat
                                prepend-icon="mdi-map-marker"
                                label="Address Line 1"
                                hide-details="auto"
                                color="primary"
                                dark
                                :rules="[validationRules.required]"
                        />
                        <v-text-field
                                v-model="companyInfo.address.line2"
                                class="pb-2"
                                flat
                                prepend-icon="mdi-map-marker"
                                label="Address Line 2"
                                hide-details="auto"
                                color="primary"
                                dark
                        >
                            <template v-slot:prepend>
                                <div class="px-3"></div>
                            </template>
                        </v-text-field>
                        <v-combobox
                                v-model="city"
                                class="pb-2"
                                flat
                                prepend-icon="mdi-map-marker"
                                label="City / Town"
                                hide-details="auto"
                                color="primary"
                                dark
                                :rules="[validationRules.required]"
                                :items="towns"
                        >
                            <template v-slot:prepend>
                                <div class="px-3"></div>
                            </template>
                        </v-combobox>
                        <v-combobox
                                v-model="companyInfo.address.region"
                                class="pb-2"
                                flat
                                prepend-icon="mdi-map-marker"
                                label="Region"
                                hide-details="auto"
                                color="primary"
                                dark
                                :rules="[validationRules.required]"
                                :items="provinces"
                        >
                            <template v-slot:prepend>
                                <div class="px-3"></div>
                            </template>
                        </v-combobox>
                        <v-text-field
                                v-model="companyInfo.address.areaCode"
                                class="pb-2"
                                flat
                                prepend-icon=""
                                label="Area Code"
                                hide-details="auto"
                                color="primary"
                                dark
                                :rules="[validationRules.required]"
                        >
                            <template v-slot:prepend>
                                <div class="px-3"></div>
                            </template>
                        </v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions class="d-flex justify-end">
                    <v-btn
                            ref="passwordBtn"
                            color="primary"
                            small
                            outlined
                            class="mr-2"
                            @click="companyInfo = base.companyInfo"
                            :disabled="savingCompanyInfo"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                            ref="passwordBtn"
                            color="primary"
                            small
                            :loading="savingCompanyInfo"
                            :disabled="savingCompanyInfo"
                            @click="postCompanyInformation"
                    >
                        Save Changes
                    </v-btn>
                </v-card-actions>
            </v-card>
            <v-card style="max-width: 600px; width: 100%" class="mx-4 my-4">
                <div class="dlg-title-bar">
                    Partner Code
                </div>
                <v-card-text>
                    <v-form ref="partnerCode" @submit="$event.preventDefault()">
                        <div class="d-flex align-center">
                            <v-text-field
                                    v-model="partnerCode"
                                    class="pb-2 flex-grow-1"
                                    flat
                                    prepend-icon="mdi-handshake"
                                    label="Partner Code"
                                    hide-details="auto"
                                    color="primary"
                                    dark
                                    :rules="[validationRules.partnerCode]"
                                    :error-messages="partnerErrors"
                            />
                        </div>

                        <div v-if="partnerCode && partnerCode === base.partnerCode">
                            <div class="body-1 font-weight-thin pt-4">
                                Partner Info:
                            </div>
                            <v-card-text>
                                <table style="width: 100%">
                                    <tr>
                                        <td>
                                            Name:
                                        </td>
                                        <td>
                                            {{partnerInfo.name}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Email:
                                        </td>
                                        <td>
                                            {{partnerInfo.email}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Contact:
                                        </td>
                                        <td>
                                            {{partnerInfo.contactNumber}}
                                        </td>
                                    </tr>
                                </table>
                            </v-card-text>
                        </div>

                    </v-form>
                </v-card-text>
                <v-card-actions class="d-flex justify-end">
                    <v-btn
                            ref="passwordBtn"
                            color="primary"
                            small
                            outlined
                            class="mr-2"
                            @click="partnerCode = base.partnerCode; partnerInfo = base.partnerInfo; partnerErrors = null"
                            :disabled="savingPartnerCode"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                            ref="passwordBtn"
                            color="primary"
                            small
                            @click="postPartnerInfo"
                            :disabled="savingPartnerCode"
                            :loading="savingPartnerCode"
                    >
                        Save Changes
                    </v-btn>
                </v-card-actions>
            </v-card>
            <v-card style="max-width: 600px; width: 100%" class="mx-4 my-4">
                <div class="dlg-title-bar">
                    Company Contacts
                </div>
                <v-card-text>
                    <v-form ref="contacts" @submit="$event.preventDefault()">
                        <!--Company Name-->
                        <v-text-field
                                v-model="contacts.contactNumber"
                                class="pb-2"
                                flat
                                prepend-icon="mdi-phone"
                                label="Company Contact Number"
                                hide-details="auto"
                                color="primary"
                                dark
                                :rules="[validationRules.required, validationRules.cellNo]"
                        />
                        <!--Billing Contact-->
                        <v-text-field
                                v-for="(con, i) in contacts.billing"
                                :key="i"
                                :value="con"
                                @input="updateContact($event, i)"
                                class="pb-2"
                                flat
                                prepend-icon="mdi-email"
                                :label="`Billing Email ${i + 1}`"
                                hide-details="auto"
                                color="primary"
                                dark
                                :rules="[validationRules.required, validationRules.email]"
                        >
                            <template v-slot:append-outer v-if="contacts.billing.length > 1">
                                <v-tooltip top>
                                    <template v-slot:activator="{on}">
                                        <v-btn
                                                icon
                                                color="error"
                                                v-on="on"
                                                @click="contacts.billing.splice(i, 1); this.$refs.contacts.resetValidation()"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </template>
                                    Remove Email Address
                                </v-tooltip>
                            </template>
                        </v-text-field>
                        <div class="d-flex justify-center">
                            <v-btn
                                    class="mt-2"
                                    small
                                    text
                                    color="primary"
                                    @click="contacts.billing.push('')"
                            >Add Billing Contact</v-btn>
                        </div>

                    </v-form>
                </v-card-text>
                <v-card-actions class="d-flex justify-end">
                    <v-btn
                            ref="passwordBtn"
                            color="primary"
                            small
                            outlined
                            class="mr-2"
                            :disabled="savingCompanyContacts"
                            @click="resetContacts"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                            ref="passwordBtn"
                            color="primary"
                            small
                            @click="postContacts"
                            :loading="savingCompanyContacts"
                            :disabled="savingCompanyContacts"
                    >
                        Save Changes
                    </v-btn>
                </v-card-actions>
            </v-card>
<!--3CX Servers Contact-->
            <v-card style="max-width: 600px; width: 100%" class="mx-4 my-4">
                <div class="dlg-title-bar">
                    CDR Server
                </div>
                <v-card-text v-if="!!cdr">
                    <v-form ref="cdrServerForm" @submit="$event.preventDefault()">
                        <v-autocomplete
                                label="Server Type"
                                v-model="cdr.type"
                                class="pb-2 flex-grow-1"
                                :items="cdrTypes"
                                flat
                                prepend-icon="mdi-desktop-classic"
                                hide-details="auto"
                                color="primary"
                                dark
                                :rules="[validationRules.required]"
                                autocomplete="chrome-off"
                                @input="cdrError = null"
                        />
                        <v-text-field
                                label="Server Address"
                                v-model="cdr.address"
                                class="pb-2 flex-grow-1"
                                flat
                                prepend-icon="mdi-web"
                                hide-details="auto"
                                color="primary"
                                dark
                                :rules="[validationRules.required]"
                                autocomplete="chrome-off"
                                @input="cdrError = null"
                        />
                        <v-text-field
                                label="Username"
                                v-model="cdr.username"
                                class="pb-2 flex-grow-1"
                                flat
                                prepend-icon="mdi-badge-account"
                                hide-details="auto"
                                color="primary"
                                dark
                                :rules="[validationRules.required]"
                                autocomplete="new-password"
                                @input="cdrError = null"
                        />
                        <v-text-field
                                label="Password"
                                v-model="cdr.password"
                                class="pb-2 flex-grow-1"
                                flat
                                prepend-icon="mdi-lock"
                                hide-details="auto"
                                color="primary"
                                dark
                                :rules="[validationRules.required]"
                                type="password"
                                autocomplete="new-password"
                                @input="cdrError = null"
                        />
                      <v-switch
                          label="Version 20+"
                          v-model="v20"
                          class="pb-2 flex-grow-1"
                          flat
                          prepend-icon="mdi-alert-box"
                          hide-details="auto"
                          color="primary"
                          dark
                          @input="cdrError = null"
                      />
                        <v-switch
                                label="CDR Collection Enabled"
                                v-model="cdr.enabled"
                                class="pb-2 flex-grow-1"
                                flat
                                prepend-icon="mdi-check-all"
                                hide-details="auto"
                                color="primary"
                                dark
                                @input="cdrError = null"
                        />
                        <div v-if="cdrError" class="pa-2 caption error--text">
                            {{cdrError}}
                        </div>

                        <div class="d-flex justify-center align-center caption overline primary--text pt-4" v-if="cdr.lastSuccess" style="line-height: 1">
                            Last Successful Pull: {{format(new Date(cdr.lastSuccess), "yyyy-MM-dd hh:mm")}}
                        </div>

                    </v-form>
                </v-card-text>
                <v-card-actions class="d-flex justify-end">
                    <v-btn
                            ref="passwordBtn"
                            color="primary"
                            small
                            outlined
                            class="mr-2"
                            @click="testCDR"
                            :disabled="loadingCDR"
                    >
                        Test Credentials
                    </v-btn>
                    <v-btn
                            ref="passwordBtn"
                            color="primary"
                            small
                            :disabled="loadingCDR"
                            :loading="loadingCDR"
                            @click="saveCDR"
                    >
                        Save Changes
                    </v-btn>
                </v-card-actions>
            </v-card>
          
          <v-card style="max-width: 600px; width: 100%" class="mx-4 my-4">
            <div class="dlg-title-bar">
              Office 365 Tenants
            </div>
            <v-card-text v-if="!!cdr">
              <div class="d-flex align-center" v-for="tenant in o365Tenants">
                <div class="body-1 flex-grow-1 py-2">
                  {{tenant.name}}
                </div>
                <v-btn
                    color="primary"
                    small
                    text
                    class="mr-2"
                    @click="disableTenant(tenant)"
                >
                  {{tenant.active ? "Disable" : "Enable"}}
                </v-btn>
                <v-btn
                    color="error"
                    small
                    text
                    class="mr-2"
                    @click="removeTenant(tenant)"
                >
                  Remove
                </v-btn>
              </div>
            </v-card-text>
            <v-card-actions class="d-flex justify-end">
              <v-btn
                  ref="passwordBtn"
                  color="primary"
                  small
                  outlined
                  class="mr-2"
                  @click="addTenant"
              >
                Add Tenant
              </v-btn>
            </v-card-actions>
          </v-card>

        </template>
    </div>
</template>

<script>

import {arrSplice, nameSort, validationRules} from "@/core/codeFunctions";
import AppCentreLoader from "@/components/Shared/AppCentreLoader";
import AppDlg from "@/components/Shared/AppDlg";
import {getServerAddress, newReq} from "@/core/request";
import {format} from "date-fns";
const places = [
    {province: "Eastern Cape", places: [ "Alice", "Aliwal North", "Bhisho", "Burgersdorp", "Butterworth", "Cradock", "Dimbaza", "East London", "Elliot", "Fort Beaufort", "Gonubie", "Graaff-Reinet", "Grahamstown", "Humansdorp", "Jeffreys Bay", "King William's Town", "Mdantsane", "Middelburg", "Umtata", "Ndevana", "Port Alfred", "Port Elizabeth", "Queenstown", "Somerset East", "Stutterheim", "Uitenhage", "Whittlesea", ]},
    {province: "Free State", places: [ "Allanridge", "Bethlehem", "Bloemfontein", "Bothaville", "Botshabelo", "Bultfontein", "Clocolan", "Deneysville", "Ficksburg", "Frankfort", "Harrismith", "Heilbron", "Hoopstad", "Kroonstad", "Ladybrand", "Marquard", "Odendaalsrus", "Parys", "Phomolong", "Phuthaditjhaba", "Reitz", "Sasolburg", "Senekal", "Thaba Nchu", "Theunissen", "Tshiame", "Viljoenskroon", "Villiers", "Virginia", "Vrede", "Welkom", "Wesselsbron", "Zastron", ]},
    {province: "Gauteng", places: [ "Bronkhorstspruit", "Carletonville", "Cullinan", "Ekangala", "Evaton", "Fochville", "Hammanskraal", "Heidelberg", "Johannesburg", "Nigel", "Pretoria", "Soshanguve", "Vereeniging", "Westonaria", ]},
    {province: "KwaZulu-Natal", places: [ "Ballito", "Clydesdale", "Dundee", "Durban", "Empangeni", "Estcourt", "Folweni", "Frischgewaagd", "Glencoe", "Greytown", "Howick", "Kokstad", "Ladysmith", "Mandini", "Margate", "Mondlo", "Mooi Rivier", "Mpophomeni", "Mpumalanga", "Mtubatuba", "Ncotshane", "Newcastle", "Pietermaritzburg", "Port Shepstone", "Richards Bay", "Shakaskraal", "Stanger", "Tongaat", "Ulundi", "Umzinto", "Vryheid", "Wembesi", ]},
    {province: "Limpopo", places: [ "Amandelbult Mine", "Warmbad", "Lebowakgomo", "Ellisras", "Louis Trichardt", "Mankweng", "Marapong", "Modimolle", "Potgietersrus", "Naboomspruit", "Musina", "Nkowankowa", "Phalaborwa", "Polokwane", "Praktiseer", "Thabazimbi", "Thohoyandou", "Tshitereke", "Vaalwater", "Tzaneen"]},
    {province: "Mpumalanga", places: [ "Balfour", "Barberton", "eMakhazeni", "Bethal", "Carolina", "Vlakpoort", "Delmas", "Dwarsloop", "Elukwatuni", "Embalenhle", "Piet Retief", "Ermelo", "Hendrina", "Kamaqhekeza", "Kinross", "Ga-Nala", "Kwaggafontein", "Leslie", "Lydenburg", "Middelburg", "Mkhuhlu", "Moloto", "Mbombela", "Phola", "Redhill", "Sabie", "Siyabuswa", "Standerton", "Tekwane", "Trichardt", "Tweefontein", "Vaalbank", "Verena", "Volksrust", "White River", "Witbank", ]},
    {province: "Northern Cape", places: [ "Barkly West", "Colesberg", "De Aar", "Douglas", "Jan Kempdorp", "Kimberley", "Postmasburg", "Ritchie", "Upington", "Warrenton", ]},
    {province: "North West", places: [ "Bloemhof", "Brits", "Christiana", "Coligny", "Hartbeestfontein", "Hartbeestfontein A", "Hartebeespoort", "Itsoseng", "Klerksdorp", "Koster", "Letlhabile", "Lichtenburg", "Mafikeng", "Rooikoppies", "Orkney", "Ottosdal", "Potchefstroom", "Rustenburg", "Schweizer-Reneke", "Stilfontein", "Ventersdorp", "Vryburg", "Wolmaransstad", "Zeerust", ]},
    {province: "Western Cape", places: [ "Atlantis", "Beaufort West", "Bredasdorp", "Cape Town", "Ceres", "George", "Grabouw", "Groot Brakrivier", "Hermanus", "Knysna", "Malmesbury", "Montagu", "Mossel Bay", "Oudtshoorn", "Paarl", "Plettenberg Bay", "Riversdale", "Robertson", "Saldanha", "Somerset West", "Stellenbosch", "Swellendam", "Vredenburg", "Vredendal", "Worcester", ]},
]


export default {
    components: {AppDlg, AppCentreLoader},
    props: {
        propName: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            validationRules,
            companyInfo: {
                name: null,
                companyName: null,
                address: {
                    line1: null,
                    line2: null,
                    city: null,
                    region: null,
                    areaCode: null,
                },
                taxNo: null,
                companyRegistrationNo: null,
            },
            contacts: {
                contactNumber: null,
                billing: [''],
            },
            phoneIpAddresses: [],
            checkingCompany: false,
            companyErrors: null,
            partnerCode: null,
            startingUp: false,
            base: null,
            savingCompanyInfo: false,
            savingCompanyContacts: false,
            loadingPartnerInfo: false,
            partnerInfo: null,
            savingPartnerCode: false,
            partnerErrors: null,
            savingPhoneServers: false,
            connectedServers: [],
            refreshServersInterval: null,
            showAdd3CXServer: false,
            add3CXServerCredentials: {
                username: null,
                password: null,
                serverAddress: null
            },
            phoneServers: [],
            testCredentialsObj: null,
            testingCredentials: false,

            loadingCDR: false,
            cdr: null,
            cdrTypes: ["3CX"],
            cdrError: null,
            format,
          loadingTenants: false,
        }
    },
    mounted() {
        this.loadCompanyData();
        this.getCDRServer();
    },
    beforeDestroy() {
        clearInterval(this.refreshServersInterval)
    },
    watch: {
        showAdd3CXServer(value) {
            if (value) {
                this.add3CXServerCredentials.username = null;
                this.add3CXServerCredentials.password = null;
                this.add3CXServerCredentials.serverAddress = null;
            }

        }
    },
    methods: {

        async postPartnerInfo() {
            this.partnerErrors = null;
            if (!this.$refs.partnerCode.validate())
                return;
            this.savingPartnerCode = true;
            try {
                const res = await this.$newReq('POST', `setup/partnerCode`, {partnerCode: this.partnerCode})
                if (!res.status)
                    return this.partnerErrors = ['Partner code not found']
                this.base.partnerCode = res.partnerCode;
                this.base.partnerInfo = res.partnerInfo;
                this.partnerInfo = res.partnerInfo
                this.$snack.info('Changes Saved')
            } catch (e) {
                this.$snack.netWorkError()
                console.log(e)
            } finally {
                this.savingPartnerCode = false
            }
        },

        resetContacts() {
            this.contacts.contactNumber = this.base.contacts.contactNumber
            arrSplice(this.contacts.billing, () => true);
            this.$nextTick(() => {
                this.contacts.billing.splice(0,0, ...this.base.contacts.billing);
            })
            this.$refs.contacts.resetValidation();
        },
        async postContacts() {
            if (!this.$refs.contacts.validate())
                return;
            this.savingCompanyContacts = true;
            try {
                const contacts = await this.$newReq('POST', `setup/contacts`, this.contacts)
                this.contacts.contactNumber = contacts.contactNumber
                arrSplice(this.contacts.billing, () => true);
                this.contacts.billing.splice(0,0, ...contacts.billing);
                this.base.contacts = JSON.parse(JSON.stringify(contacts))
                this.$snack.info('Changes Saved')
            } catch (e) {
                this.$snack.netWorkError()
                console.log(e)
            } finally {
                this.savingCompanyContacts = false
            }
        },
        async postCompanyInformation() {
            if (!this.$refs.companyInfo.validate())
                return;
            this.savingCompanyInfo = true;
            try {
                const {status: duplicateSiteName} = await this.$newReq('POST', `setup/checkSiteName`, {name: this.companyInfo.name})
                if (duplicateSiteName)
                    return this.companyErrors = ['Site name already exists']
                const companyInfo = await this.$newReq('POST', `setup/companyInformation`, this.companyInfo)
                Object.assign(this.companyInfo, companyInfo)
                this.base.companyInfo = JSON.parse(JSON.stringify(companyInfo))
                this.$snack.info('Changes Saved')
            } catch (e) {
                this.$snack.netWorkError()
                console.log(e)
            } finally {
                this.savingCompanyInfo = false
            }
        },
        async loadCompanyData() {
            try {
                this.startingUp = true
                const data = await this.$newReq('GET', `setup/companyInformation`)
                this.base = JSON.parse(JSON.stringify(data))
              this.o365Tenants = data.o365Tenants || []
                this.companyInfo = data.companyInfo;
                this.contacts.contactNumber = data.contacts.contactNumber;
                this.partnerInfo = data.partnerInfo;
                this.partnerCode = data.partnerCode;
                this.base.partnerInfo = JSON.parse(JSON.stringify(data.partnerInfo || null))
                arrSplice(this.contacts.billing, () => true);
                this.contacts.billing.splice(0,0, ...data.contacts.billing);
                // this.contacts = data.contacts;
            } catch (e) {
                this.$snack.netWorkError()
                console.log(e)
            } finally {
                this.startingUp = false
            }
        },
        updateContact(value, index) {
            this.contacts.billing[index] = value
        },
        async getCDRServer() {
            this.loadingCDR = true
            try {
                const res = await newReq('GET', 'setup/cdr')
                if (!res)
                    this.cdr = {
                        type: null,
                        username: null,
                        password: null,
                        address: null,
                        siteId: null,
                        enabled: true
                    }
                else
                    this.cdr = res
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.loadingCDR = false
            }
        },
      async addTenant() {
        window.location.assign(`${getServerAddress()}/auth/microsoft/init/${this.$store.state.curSiteId}`)
      },
      async disableTenant(tenant) {
        this.loadingTenants = true
        try {
          this.cdrError = null
          const res = await newReq('POST', 'setup/o365Tenants/disable', tenant)
          await this.loadCompanyData()
        } catch (e) {
          console.log(e)
          this.$snack.netWorkError();
        } finally {
          this.loadingTenants = false
        }
      },
      async removeTenant(tenant) {
        this.loadingTenants = true
        try {
          this.cdrError = null
          const res = await newReq('POST', 'setup/o365Tenants/remove', tenant)
          await this.loadCompanyData()
        } catch (e) {
          console.log(e)
          this.$snack.netWorkError();
        } finally {
          this.loadingTenants = false
        }
      },
        async testCDR() {

            if (!this.$refs.cdrServerForm.validate())
                return false

            this.loadingCDR = true
            try {
                this.cdrError = null
                const res = await newReq('POST', 'setup/cdr/test', this.cdr)
                if (res.status)
                    this.$snack.info('Success')
                else {
                    this.$snack.error('Test Failed')
                    this.cdrError = res.message
                }
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.loadingCDR = false
            }
        },
        async saveCDR() {
            if (!this.$refs.cdrServerForm.validate())
                return false

            this.loadingCDR = true
            try {
                this.cdrError = null
                await newReq('PATCH', 'setup/cdr', this.cdr)
                this.$snack.info('Changes Saved')
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.loadingCDR = false
            }
        }
    },
    computed: {
        city: {
            get() {
                return this.companyInfo.address.city
            },
            set(val) {
                this.companyInfo.address.region = null;
                this.companyInfo.address.city = val;
                if (val)
                    places.forEach(place => {
                        if (place.places.find(town => town === val))
                            this.companyInfo.address.region = place.province
                    })
            }
        },
        towns() {
            return places.reduce((list, place) => {
                return list.concat(place.places)
            }, []).sort(nameSort)
        },
        provinces() {
            return places.map(place => place.province).sort(nameSort)
        },
      v20: {
          get() {
            return this.cdr.v20 || false
          },
          set(val) {
            this.$set(this.cdr, "v20", val)
          }
      }
    },

}
</script>

<style scoped>

</style>